import { useClearRefinements, useSortBy } from 'react-instantsearch';
import useQueryParam from './useQueryParam';
import { useSearchClient } from '@javascript/instant_search/provider/searchClientProvider';
import useCurrentSortOrder from '@javascript/instant_search/hooks/useCurrentSortOrder';

export function useCustomClearRefinements() {
  const { indexName } = useSearchClient();
  const clearRefinements = useClearRefinements({
    excludedAttributes: ['branchID', 'query'],
  });
  const [postcodeParam, setPostcodeParam] = useQueryParam('location');
  const [distanceParam, setDistanceParam] = useQueryParam('distance');
  const sortByRefinement = useSortBy({
    items: [{ value: '_monthly_asc', label: 'Monthly payment' }],
  });
  const currentSortOrder = useCurrentSortOrder();

  const customRefine = () => {
    if (postcodeParam) setPostcodeParam('');
    if (distanceParam) setDistanceParam('');
    clearRefinements.refine();
    if (currentSortOrder && currentSortOrder.includes('geolocation')) {
      sortByRefinement.refine(indexName + '_monthly_asc');
    }
  };

  return {
    ...clearRefinements,
    refine: customRefine,
  };
}
